import { render, staticRenderFns } from "./CarBookings.vue?vue&type=template&id=53117d1c&"
import script from "./CarBookings.vue?vue&type=script&lang=js&"
export * from "./CarBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports